import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, DeviceCertificate } from "@preveil-api";
import { CheckboxStates, CheckboxStatesTypes, DriveUIActionTypes } from "src/common";
import { Checkbox, EmptyView, Loading } from "src/components";
import { ListRow } from "..";
import _ from "lodash";

type AllProps = {
  is_loading: boolean;
  certificates: DeviceCertificate[];
  selected: string[];
  handleAction: ActionHandlerFunction;
};

function ListViewComponent(props: AllProps) {
  const { is_loading, selected, certificates, handleAction } = props;

  // Description: Get the selected all checkbox state
  function getSelectedState(): CheckboxStatesTypes {
    let ck_state: CheckboxStatesTypes = CheckboxStates.empty;
    ck_state = !selected.length
      ? CheckboxStates.empty
      : selected.length < certificates.length
        ? CheckboxStates.indeterminate
        : CheckboxStates.checked;
    return ck_state;
  }

  // Description: Render the rows of Admin Users view
  function RenderList(_list: DeviceCertificate[]) {
    return (
      <div className="list-body">
        {_.map(_list, (_certificate: DeviceCertificate, i: number) => {
          return (
            <ListRow
              key={`item_${i}`}
              certificate={_certificate}
              handleAction={handleAction}
              selected={selected.includes(_certificate.id)}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div className={`admin-list-view device-settings ${is_loading ? " isloading" : ""}`}>
      {!!certificates && certificates.length > 0 && (
        <Row className="header-row">
          <Col md="1">
            <Checkbox
              className="sr-only"
              onChange={(e: FocusEvent<HTMLInputElement>) => {
                handleAction({
                  actionType: DriveUIActionTypes.Select,
                  params: { selected: e.target.checked },
                });
              }}
              value="all"
              label="Select All"
              selected={getSelectedState()}
            />
          </Col>
          <Col md="3" className="col">Issued To</Col>
          <Col md="3">Issued By</Col>
          <Col md="3">Expiration Date</Col>
          <Col md="2">Friendly Name</Col>
        </Row>
      )}
      {!!certificates && certificates.length > 0 ? (
        RenderList(certificates)
      ) : !is_loading ? <EmptyView message="No matches found!" /> : null}

      {is_loading && <Loading />}
    </div>
  );
}

export default React.memo(ListViewComponent);
